export default __webpack_public_path__ + "static/media/fullScreen.573e4270.svg";